import React from 'react';
import { Link } from 'react-router-dom';

/** 简体中文服务条款 */
export default function TermsZh() {
  return (
    <>
      <h1>服务条款</h1>
      <p className="muted">生效日期：2026年5月27日 · 最后更新：2026年5月27日</p>
      <p className="lede">
        本条款适用于 <strong>omw（在路上了）</strong>移动应用、API 及 onmyway.city 网站（合称「服务」）。创建账户或使用服务即表示你同意本条款及<Link to="/privacy">隐私政策</Link>。如不同意，请勿使用 omw。
      </p>

      <h2>1. 服务性质</h2>
      <p>
        omw 由独立个人开发者运营。本平台是<strong>社区型</strong>同城活动与地图发现工具，<strong>不是</strong>专业向导、紧急救援或户外保障服务。
      </p>

      <h2>2. 使用资格</h2>
      <ul>
        <li>你须年满 <strong>13</strong> 周岁（或所在司法辖区规定的更高年龄，如欧盟部分地区 16 周岁、中国 14 周岁）。</li>
        <li>未满 18 周岁应在家長/监护人知情下使用。</li>
        <li>被依法禁止使用或曾被我们封禁的用户不得注册。</li>
      </ul>

      <h2>3. 账户</h2>
      <ul>
        <li>妥善保管登录信息，对账户下行为负责。</li>
        <li>禁止冒充他人、批量注册规避封禁。</li>
        <li>可疑盗号请立即联系 <a href="mailto:safety@onmyway.city">safety@onmyway.city</a>。</li>
        <li>可随时删除账户：个人资料 → 设置 → 账户 → 删除账户。</li>
      </ul>

      <h2>4. 社区规范</h2>
      <p>参考 Instagram、小红书等 UGC 平台的社区标准，你同意：</p>
      <ul>
        <li>尊重他人，禁止骚扰、霸凌、仇恨言论、威胁与恶意人肉。</li>
        <li>禁止涉及未成年人的色情内容；禁止非自愿私密影像。</li>
        <li>禁止 spam、刷量、虚假活动/商家信息与欺诈性优惠券。</li>
        <li>尊重知识产权，仅上传你有权发布的内容。</li>
        <li>善用拉黑与举报；违规内容可能被删除，账号可能被限制或封禁。</li>
      </ul>

      <h2>5. 位置与户外行为准则</h2>
      <p>借鉴 Geocaching、AllTrails 等户外社区的通行规范：</p>
      <ul>
        <li><strong>守法：</strong>禁止非法闯入私人领地、军事/政府禁区等。</li>
        <li><strong>安全：</strong>自行评估天气、地形与体力；危险时立即撤离。</li>
        <li><strong>无痕：</strong>不破坏环境与文物，带走垃圾。</li>
        <li><strong>负责任地放置内容：</strong>不在悬崖、轨道、隧道、施工区、危险水域等位置发布宝藏、活动或路线。</li>
        <li><strong>尊重社区：</strong>未经同意不在居民区或商家处组织扰民聚集。</li>
      </ul>
      <p>去哪里、如何行动由你自行决定并承担风险。</p>

      <h2>6. 活动、见面与交友</h2>
      <ul>
        <li>线下见面存在风险，建议公共场所、告知亲友、相信直觉。</li>
        <li>活动由发布者负责，我们不对每位参与者做背景调查。</li>
        <li>交友相关功能为可选。</li>
      </ul>

      <h2>7. 用户内容与授权</h2>
      <p>
        你保留内容所有权。为运营服务，你授予 omw 全球性、非独占、免版税许可，以在应用内展示、存储与传输该内容。删除内容后许可终止（备份保留期及法律要求除外）。
      </p>

      <h2>8. 商家与认证创作者</h2>
      <ul>
        <li>企业验证代表我们完成的身份核验，<strong>不等于</strong>对商品/服务质量的背书。</li>
        <li>商家须履行优惠券承诺并遵守当地广告与消费者法规。</li>
        <li>虚假认证、券码欺诈、冒充企业将导致封号。</li>
      </ul>

      <h2>9. Premium 与内购</h2>
      <ul>
        <li>Premium 通过 Apple 内购计费；退款遵循 Apple 政策。</li>
        <li>TestFlight 等促销权益可能调整或终止。</li>
        <li>应用内虚拟物品（如「芝士」余额）无现金价值，除明示外不可转让。</li>
      </ul>

      <h2>10. AI 生成内容</h2>
      <p>AI 输出可能不准确或有误。发布前请自行审核；勿将 AI 内容用于法律、医疗或关键安全决策。</p>

      <h2>11. 禁止行为</h2>
      <ul>
        <li>违法或侵犯他人权利；爬取、逆向工程（法律允许除外）。</li>
        <li>绕过限流、地理围栏、拉黑或审核。</li>
        <li>操纵榜单、号召力或 engagement 数据。</li>
        <li>传播恶意软件、未授权访问系统或账户。</li>
        <li>滥用 SOS 功能恶作剧。</li>
      </ul>

      <h2>12. 处理、举报与申诉</h2>
      <p>通过应用内举报或 <a href="mailto:safety@onmyway.city">safety@onmyway.city</a> 联系我们。我们可在无需事先通知的情况下删除内容或封禁账户。可邮件申诉并说明用户名与理由。</p>

      <h2>13. 安全免责声明</h2>
      <p>地图、路线、宝藏与活动多为用户生成或 AI 辅助，可能存在偏差或过时信息。你须像使用 AllTrails、Geocaching 或社交平台一样<strong>自行负责</strong>安全与合规。</p>

      <h2>14. SOS 与紧急功能</h2>
      <p>omw <strong>不能</strong>替代报警或急救。SOS 仅通知附近用户，不保证救援。遇紧急状况请先拨打当地急救电话。</p>

      <h2>15. 第三方服务</h2>
      <p>地图、聊天、登录、AI 等第三方见隐私政策，其条款亦可能适用。</p>

      <h2>16. 终止</h2>
      <p>你可随时停止使用。我们可因违规、风险或法律要求暂停或终止服务。免责声明、责任限制等依其性质在终止后继续有效。</p>

      <h2>17. 免责声明与责任限制</h2>
      <p>
        服务按「现状」提供。在法律允许的最大范围内，我们不承担间接、附带、特殊、后果性或惩罚性损害，也不对利润、数据或商誉损失负责。任何索赔下我们的总责任以你在索赔前 12 个月向我们支付的金额与 50 美元中的较高者为准。强制性消费者权利不受影响。
      </p>

      <h2>18. 赔偿</h2>
      <p>因你的内容、线下行为或违反本条款而引起的第三方索赔，你在法律允许范围内应赔偿我们因此遭受的损失。</p>

      <h2>19. 适用法律</h2>
      <p>
        本条款适用<strong>澳大利亚新南威尔士州</strong>法律。你所在国家/地区的强制性消费者保护仍然有效。完整英文版条款与英文隐私政策配套适用；冲突时以对用户更有利的强制性规定为准。
      </p>

      <h2>20. 变更与联系</h2>
      <p>
        我们可能更新条款，重大变更将在应用内或邮件通知。继续使用视为接受。
        <br />
        法律：<a href="mailto:legal@onmyway.city">legal@onmyway.city</a> · 支持：<a href="mailto:support@onmyway.city">support@onmyway.city</a> · 安全：<a href="mailto:safety@onmyway.city">safety@onmyway.city</a>
      </p>
    </>
  );
}
